export class GlobalLoading {
  private static instance: HTMLElement | null = null
  private static isDark = document.documentElement.classList.contains('dark')

  static create() {
    if (this.instance) return

    // 创建 loading 元素
    const loading = document.createElement('div')
    loading.id = 'global-loading'
    loading.className = `global-loading ${this.isDark ? 'dark' : ''}`

    // 添加 loading 内容，根据主题使用不同的 logo
    loading.innerHTML = `
      <div class="loading-content">
        <img
          class="loading-logo"
          src="${this.isDark ? '/Logo_full_brand_color.webp' : '/Logo_full_brand_color_1.webp'}"
          alt="Logo"
        />
      </div>
    `

    // 添加到 body
    document.body.appendChild(loading)
    this.instance = loading

    // 监听主题变化
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          const isDark = document.documentElement.classList.contains('dark')
          this.isDark = isDark
          if (this.instance) {
            this.instance.classList.toggle('dark', isDark)
            const logoImg = this.instance.querySelector('.loading-logo') as HTMLImageElement
            if (logoImg) {
              logoImg.src = isDark ? '/Logo_full_brand_color.webp' : '/Logo_full_brand_color_1.webp'
            }
          }
        }
      })
    })

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    })

    // 添加样式
    if (!document.getElementById('global-loading-style')) {
      const style = document.createElement('style')
      style.id = 'global-loading-style'
      style.textContent = `
        .global-loading {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #fff;
          z-index: 9999;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: opacity 0.3s ease;
          opacity: 1;
        }

        .global-loading.dark {
          background: #1a1a1a;
        }

        .global-loading.hide {
          opacity: 0;
          pointer-events: none;
        }

        .loading-logo {
          width: 520px;
          height: auto;
          animation: pulse 2s infinite;
        }

        @media (max-width: 768px) {
          .loading-logo {
            width: 320px;
            height: auto;
            animation: pulse 2s infinite;
          }
        }

        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }
      `
      document.head.appendChild(style)
    }
  }

  static open() {
    if (!this.instance) {
      this.create()
    }
    this.instance?.classList.remove('hide')
    document.body.style.overflow = 'hidden' // 防止滚动
  }

  static close() {
    if (!this.instance) return

    this.instance.classList.add('hide')
    document.body.style.overflow = '' // 恢复滚动

    // 等待过渡动画完成后移除元素
    setTimeout(() => {
      if (this.instance?.parentNode) {
        this.instance.parentNode.removeChild(this.instance)
        this.instance = null
      }
    }, 300)
  }
}

// 创建初始 loading
GlobalLoading.create()

export default GlobalLoading
